import Vue from 'vue'
import Vuex from 'vuex'
import vuexAlong from  'vuex-along';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';


Vue.use(Vuex)

export default new Vuex.Store({
    namespaced: true,  //多出的一行
    state,
    mutations,
    actions,
    getters,
    plugins: [vuexAlong({
        name:"vuex-along",
        //只持久化登录态小字段,避免 routeList/menu 等大对象撑爆 localStorage(5MB)。
        //isFilter:false => list 为白名单(pick),只存这些;其余字段刷新后由后端/导航重建。
        local:{
            list:['userName','roles','deptCode','businessLine','staffCode','leaderFirst','staffStatus','tokens'],
            isFilter:false
        },
        session:false
    })]
})



// WEBPACK FOOTER //
// ./src/store/index.js